import React from 'react';

import Spinner from '../../UI/Spinner';

import styles from './PageSpinner.module.scss';

function PageSpinner() {
  return (
    <div className={styles.spinnerContainer} data-testid="page-spinner">
      <Spinner />
    </div>
  );
}

export default PageSpinner;
